import { CARTEIRAS_CHANGED, CARTEIRA_SELECTED } from "../../const/actionsType";

export function acCarteirasChanged(pObj) {
  return {
    type: CARTEIRAS_CHANGED,
    payload: pObj,
  };
}

export function acCarteiraSelected(pObj) {
  return {
    type: CARTEIRA_SELECTED,
    payload: pObj,
  };
}
